const replaceSeperatorsInKeys = (filterObj: {}, from: string, to: string) =>
    Object.fromEntries(Object.entries(filterObj).map(([k, v]) => [k.split(from).join(to), v]));
export default replaceSeperatorsInKeys;
